import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { User } from './models/fileCode.model';
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie-service';



@Injectable()
export class ServicesService {

    apiUrl = environment.apiUrl;
    url: string;
    constructor(private _http: HttpClient, private cookieService: CookieService) {
        this.url  = 'https://api.datamuse.com/words?ml=';
    }

    checkLogin(login) {
        const data = {email: login.name , password: login.password};
        // const reqHeader = new HttpHeaders({'Content-Type': 'application/x-www-urlencodeed'});
        return this._http.post(this.apiUrl + '/login', data);
    }

    search_word(term): Observable<{}> {
        return this._http.get<{}>(this.apiUrl + '/getClientName?ml=' + term);
    }

    getShoots(id): Observable<{}> {
        return this._http.get<{}>(this.apiUrl + '/getShoots?id=' + id);
    }

    getFileCodes(): Observable<User[]> {
        return this._http.get<User[]>('https://jsonplaceholder.typicode.com/users');
    }

    contatUsPhotographer(register): Observable<{}> {
        return this._http.post<{}>(this.apiUrl + '/photographer/contact-us', register);
    }

    registerUser(param): Observable<{}> {
        // const reqHeader = new HttpHeaders({'X-Requested-With': 'XMLHttpRequest'});
        return this._http.post<{}>(this.apiUrl + '/registerUser', param);
    }

    getUserData(param): Observable<{}> {
        // const data = {token: param.token};
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + param.token);
        return this._http.post<{}>(this.apiUrl + '/user', '', {headers : other_header});
    }
    getimagesCategoryWise(): Observable<{}> {
        return this._http.get<User[]>(this.apiUrl + '/getimagesCategoryWise');
    }

    getJob(jobid): Observable<{}> {
        return this._http.get<{}>(this.apiUrl + '/job/getjob?jobid=' + jobid );
    }
    getNewJob(jobid): Observable<{}> {
        return this._http.get<{}>(this.apiUrl + '/job/getNewJob?jobid=' + jobid );
    }

    getImage(data): Observable<{}>{
        return this._http.post<{}>(this.apiUrl + '/job/getimage', data);
    }

    getJobproduct(data): Observable<{}>{
        return this._http.post<{}>(this.apiUrl + '/job/getjobproduct', data);
    }

    cartCount(param): Observable<{}> {
        // const data = {id: param.id};
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + param.token);
        return this._http.post<{}>(this.apiUrl + '/cart/getcount', '', {headers : other_header});
    }

    checkAdditionalProductAddToCart(data): Observable<{}> {
        return this._http.post<{}>(this.apiUrl + '/cart/checkadditionalproductaddtocart', data);
    }

    checkAdditionalProd(data): Observable<{}> {
        return this._http.post<{}>(this.apiUrl + '/cart/checkAdditionalProd', data);
    }

    getClientName(clientid): Observable<{}> {
        return this._http.get<{}>(this.apiUrl + '/client/getclientname?client_id=' + clientid);
    }

    getProduct(productid): Observable<{}> {
        return this._http.get<{}>(this.apiUrl + '/product/getproduct?product_id=' + productid);
    }
    getPhotos(jobid): Observable<{}> {
        return this._http.get<{}>( this.apiUrl + '/job/getphotos?job_id=' + jobid);
    }

    getJObName(jobid): Observable<{}> {
        return this._http.get<{}>( this.apiUrl + '/job/getjobname?job_id=' + jobid);
    }

    saveFileName(param): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/dashboard/save-filename',param);
    }

    getUserFile(param): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + param.token);
        return this._http.post<{}>(this.apiUrl + '/dashboard/get-filename', '', {headers : other_header});
    }

    getOrder(param): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + param.token);
        return this._http.post<{}>(this.apiUrl + '/order/get-order', '', {headers : other_header});
    }

    addproduct(data): Observable<{}> {

        const PHPSESSID     = this.cookieService.get('PHPSESSID');
        const header        = new HttpHeaders();
        const other_header  = header.append('PHPSESSID', PHPSESSID);
        return this._http.post<{}>( this.apiUrl + '/cart/addproduct', data, {headers : other_header});
    }

    getCartDetails(data): Observable<{}> {
        const PHPSESSID     = this.cookieService.get('PHPSESSID');
        const header        = new HttpHeaders();
        const other_header  = header.append('PHPSESSID', PHPSESSID);

        return this._http.post<{}>( this.apiUrl + '/cart/getcartproduct', data, {headers: other_header});
    }

    onChangeQuantity(data): Observable<{}> {
        const PHPSESSID     = this.cookieService.get('PHPSESSID');
        const header        = new HttpHeaders();
        const other_header  = header.append('PHPSESSID', PHPSESSID);

        return this._http.post<{}>( this.apiUrl + '/cart/update-quantity', data, {headers: other_header});
    }

    deleteProduct(data): Observable<{}> {
        const PHPSESSID     = this.cookieService.get('PHPSESSID');
        const header        = new HttpHeaders();
        const other_header  = header.append('PHPSESSID', PHPSESSID);

        return this._http.post<{}>( this.apiUrl + '/cart/delete-product', data, {headers: other_header});
    }

    getPrivateImage(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/job/get-private-image', data);
    }

    getOrderDetails(data): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + data.token);
        return this._http.post<{}>(this.apiUrl + '/order/get-order-detail', data, {headers : other_header});
    }

    checkoutProduct(data): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + data.token);
        return this._http.post<{}>(this.apiUrl + '/order/match-price', data, {headers : other_header});
    }

    //Payment response callback
    /*createOrder(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/order/create-order', data);
    }*/
    //Payment response callback

    changePassword(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/password/change', data);
    }

    authenticateUser(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/user/authenticate', data);
    }

    forgetPassword(data): Observable<{}> {
        const header        = new HttpHeaders();
        header.append('X-Requested-With', 'XMLHttpRequest');
        const other_header  = header.append('Accept', 'application/json');
        return this._http.post<{}>( this.apiUrl + '/password/email', data, {headers: other_header});
    }

    resetPassword(data): Observable<{}> {
        const header        = new HttpHeaders();
        header.append('X-Requested-With', 'XMLHttpRequest');
        const other_header  = header.append('Accept', 'application/json');
        return this._http.post<{}>( this.apiUrl + '/password/reset', data, {headers: other_header});
    }

    verifyAccount(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/user/verification', data);
    }
    // Payment API sTART
    getCheckout(data): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + data.token);
        return this._http.post<{}>(this.apiUrl + '/payment/get-checkout', '', {headers : other_header});
    }

    getPaymentStatus(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/payment/get-payment-status', data);
    }

    // Payment API eND

    verifyUserAccount(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/user/verify-account', data);
    }
    updateAddress(data): Observable<{}> {
        return this._http.post<{}>( this.apiUrl + '/user/update-address', data);
    }
    getorderPrice(data): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + data.token);
        return this._http.post<{}>(this.apiUrl + '/cart/order-price', '', {headers : other_header});
    }

    getPaymentKey(data): Observable<{}> {
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + data.token);
        return this._http.post<{}>(this.apiUrl + '/eftpayment/payment-key', data, {headers : other_header});
    }

    getShipmentCharge(data): Observable<{}> {
        //sevice changed from get to post for getting user token
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + data.token);
        return this._http.post<{}>( this.apiUrl + '/job/get-shipment-charge', data, {headers : other_header});
    }

    

    getPaymentStatusTest(data): Observable<{}> {
        return this._http.post<{}>( 'https://testsecure.peachpayments.com/checkout', data);
    }

    deleteUserAccount(param): Observable<{}> {
        // const data = {token: param.token};
        const header        = new HttpHeaders();
        const other_header  = header.append('Authorization', 'Bearer ' + param.token);
        return this._http.post<{}>(this.apiUrl + '/delete/user/account', '', {headers : other_header});
    }


}



// WEBPACK FOOTER //
// /var/www/html/oneills-web-qa/src/app/services.service.ts